/**
 * Cómo funciona — subtle Apple-style reveal. The panel and image rise/fade in
 * when scrolled into view; once the panel is visible, its steps cascade in with
 * a small stagger. Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHow = (section) => {
    const reveals = Array.from(section.querySelectorAll('[data-how-reveal]'));
    if (!reveals.length) return;

    const steps = Array.from(section.querySelectorAll('[data-how-step]'));
    steps.forEach((step, i) => step.style.setProperty('--how-step-delay', `${0.15 + i * 0.12}s`));

    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach((t) => t.classList.add('is-visible'));
      return;
    }

    reveals.forEach((t, i) => t.style.setProperty('--how-reveal-delay', `${i * 0.12}s`));

    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    reveals.forEach((t) => io.observe(t));
  };

  const boot = () => document.querySelectorAll('[data-how]').forEach(initHow);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-how]');
    if (section) initHow(section);
  });
})();
